import { useEffect, useMemo, useRef } from "react"
import { useState } from "react"

import { Modal, TableCustom, FormLabel } from "../../../../../components/common"
import ListasModal from "../../../../../components/controls/ListasModal"
import { TIPOS_VINCULO_CUENTA } from "../../../utils"
import {TIPS} from "../../../../../consts/tips";


const RelacionesPermitidas = ({ data, setData, params, idTipoTributo, tiposVinculoCuenta, disabled }) => {
    const [open, setOpen] = useState(false)
    const [adding, setAdding] = useState(false)
    const firstRenderRef = useRef(true)

    const filteredData = useMemo(() => tiposVinculoCuenta.filter(
        entity => data.some(item => item.state !== 'r' && entity.id === item.idTipoVinculoCuenta)
    ), [data, tiposVinculoCuenta])

    useEffect(() => {
        if (firstRenderRef.current) {
            firstRenderRef.current = false
            return
        }
        if (idTipoTributo && idTipoTributo > 0 && data && data.length > 0 && tiposVinculoCuenta && tiposVinculoCuenta.length > 0) {
            //por cada tipo de vinculo obsoleto (los que eran un tipo de tributo anterior), los debo remover
            // const tiposVinculoCuentaXActuales = filteredData.map(x => x.id);
            const tiposVinculoCuentaXActuales = tiposVinculoCuenta.filter(entity => data.some(item => item.state !== 'r' && entity.id === item.idTipoVinculoCuenta)).map(x => x.id);
            const tiposVinculoCuentaObsoletos = data.filter(item => item.state !== 'r' && !tiposVinculoCuentaXActuales.includes(item.idTipoVinculoCuenta));
            onRemoveByIds(tiposVinculoCuentaObsoletos.map(x => x.idTipoVinculoCuenta))
        }
    }, [idTipoTributo])

    const onAddConfirm = (id) => {
        if (data.find(x => x.idTipoVinculoCuenta === id))
            setData(data.map(x => x.idTipoVinculoCuenta === id ? {...x, state: 'o'} : x))
        else setData([...data, {
            id: -Date.now(),
            idPlanPagoDefinicion: parseInt(params.id),
            idTipoVinculoCuenta: id,
            state: 'a',
        }])

        setAdding(false)
    }

    const onRemoveByIds = (ids) => {
        const result = []
        data.forEach(x => {
            if (ids.includes(x.idTipoVinculoCuenta)) {
                if (x.state !== 'a') result.push({...x, state: 'r'})
            }
            else {
                result.push(x)
            }
        })
        setData(result)
    }

    const onRemove = (item) => {
        const result = []
        data.forEach(x => {
            if (x.idTipoVinculoCuenta === item.id) {
                if (x.state !== 'a') result.push({...x, state: 'r'})
            }
            else {
                result.push(x)
            }
        })
        setData(result)
    }

    const inputText = filteredData.length < 1 ? '' : (filteredData[0].nombre + (filteredData.length > 1 ? '...' : '') )

    const tableColumns = [
        { Header: 'Nombre', accessor: 'nombre', width: '95%' },
        {
            id:'ar', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true,
            Header: (props) => disabled ? <div/> : (
                <div className='action'>
                    <div onClick={() => setAdding(true)} className="link">
                        <span className="material-symbols-outlined" title="Nuevo">add</span>
                    </div>
                </div>
            ),
            Cell: (props) =>  disabled ? <div/> : (
                <div className='action'>
                    <div onClick={() => onRemove(props.row.original)} className="link">
                    <span className="material-symbols-outlined" title="Eliminar">delete</span>
                    </div>
                </div>
            ),
        },
    ]

    return <>
        <div className="col-12 col-md-6 col-lg-4">
            <FormLabel htmlFor="idTipoVinculoCuenta" required>Relaciones permitidas</FormLabel>
            <input
                name="idTipoVinculoCuenta"
                type="text"
                placeholder=""
                className={disabled ? 'form-control input-entida link force-disabled' : 'form-control input-entidad link'}
                value={inputText}
                onClick={() => setOpen(true)}
                // disabled={params.mode === OPERATION_MODE.VIEW}
                readOnly
            />
        </div>

        <Modal
            onEscape={() => setOpen(false)}
            show={open}
            title="Relaciones permitidas"
            tipName={TIPS.NAME.MODALS.RELACIONES_PERMITIDAS_MODAL}
            body={
                <div className="row">
                    <TableCustom
                        className='TableCustomBase'
                        columns={tableColumns}
                        data={filteredData}
                    />
                </div>
            }
            footer={<div className="width-100p f-align">
            <button className="btn back-button" data-dismiss="modal" onClick={() => setOpen(false)}>Volver</button>
            </div>}
        />

        {adding && <ListasModal
            title="Relaciones permitidas"
            tipName={TIPS.NAME.MODALS.RELACIONES_PERMITIDAS_MODAL}
            lista={TIPOS_VINCULO_CUENTA[idTipoTributo]}
            onDismiss={() => { setAdding(false) }}
            onConfirm={onAddConfirm}
        />}
    </>
}

export default RelacionesPermitidas
